import React from 'react';
import SettingsPage from '../../components/settings-page/SettingsPage';
import { ScreenGlobalSettings } from '../../classes/consts/Screen';
import { useAuth } from '../../contexts/auth';

export default function GlobalSettings() {
    const { sessionDetail } = useAuth();

    return (
        <SettingsPage
            screenConst={ScreenGlobalSettings}
            titleMessageKey={sessionDetail?.EnterpriseMode ? "GlobalSettingsScreen_Title" : "SettingsScreen_Title"}
        />
    );
}
